import store from "../store/store";
import { queryClient } from "./queryClient";
import { logout } from "../reducers/AuthSlice";

// Ends the session without a page reload. The logout action resets the store
// and removes the auth keys
// Device preferences (areaUnit, tileLayer) are kept.
export const endSession = () => {
  queryClient.cancelQueries();
  queryClient.clear();
  store.dispatch(logout());
  localStorage.removeItem("indices");
  Object.keys(localStorage)
    .filter((key) => key.startsWith("tileVisibilityState_"))
    .forEach((key) => localStorage.removeItem(key));
};
